export const useCelloAttribution = () => {
  const getCelloUcc = async () => {
    if (typeof window.CelloAttribution !== 'function') {
      return null;
    }

    try {
      const ucc = await window.CelloAttribution('getUcc');

      return typeof ucc === 'string' && ucc.length > 0
        ? ucc
        : null;
    } catch (error) {
      return null;
    }
  };

  return {
    getCelloUcc,
  };
};
